import { render, staticRenderFns } from "./ENotaInputResultadoTexto.vue?vue&type=template&id=181651f8"
import script from "./ENotaInputResultadoTexto.vue?vue&type=script&lang=js"
export * from "./ENotaInputResultadoTexto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports